// src/api/attendance/attendanceApi.js
import apiClient from '../index';

export const generateAttendance = async (eventData) => {
    try {
        const response = await apiClient.post('/api/attendance/generate', eventData);
        return response.data;
    } catch (error) {
        console.error('Error generating attendance:', error);
        throw error;
    }
};

export const markAttendance = async ({ attendanceId, isPresent }) => {
    try {
        const response = await apiClient.post(`/api/attendance/${attendanceId}`, { isPresent });
        return response.data;
    } catch (error) {
        console.error(`Error marking attendance with ID ${attendanceId}:`, error);
        throw error;
    }
};

export const deleteAttendance = async (attendanceId) => {
    if (!attendanceId) throw new Error('Attendance ID is required');

    try {
        const response = await apiClient.delete(`/api/attendance/${attendanceId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting attendance with ID ${attendanceId}:`, error);
        throw error;
    }
};

export const getEventAttendance = async (eventId) => {
    if (!eventId) throw new Error('Event ID is required');

    try {
        const response = await apiClient.get(`/api/attendance/event/${eventId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching attendance for event with ID ${eventId}:`, error);
        throw error;
    }
};